// deviceConfigure.js
// external libs
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'
import { useNavigate, useParams } from 'react-router-dom'

import Footer from '../partials/Footer'
import NavigationBar from '../partials/NavigationBar'
import SettingHistory from '../partials/SettingPageComponents/SettingHistory/SettingHistoryMain'
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/devicePage.module.css'
import AppDispatcher from '../../dispatchers/AppDispatcher'

function SettingHistoryPage (props) {
  const navigate = useNavigate()
  const { deviceID, customerID } = useParams()

  const goTo = React.useCallback((x) => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    goTo(`/${customerID}/devices/${deviceID}/settings`)
    unloadSettingsHistory()
  }, [customerID, deviceID, goTo])

  const unloadSettingsHistory = React.useCallback(() => {
    AppDispatcher.dispatch({ action: 'unload-settings-history' })
  }, [])

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const {
    auth: {
      logout,
    },
    intl: {
      formatMessage,
    },
    route: {
      path: page,
    },
    data: { deviceSettingHistory: { data, ready } } = {},
    level,
  } = props

  const ADMIN = formatMessage({
    id: 'setting.settingHistory',
    defaultMessage: 'Settings History',
    description: 'Settings History label',
  })

  const {
    pages: {
      CustomerSettingsPage: title = ADMIN,
    },
  } = props

  // Normalize data to always be an object (SettingHistoryMain expects an object)
  // If data is an array (from unloadSettingHistory), convert it to object format
  const normalizedData = Array.isArray(data)
    ? { entries: data, total_count: data.length, limit: data.length }
    : data || { entries: [], total_count: 0, limit: 0 }

  return (
    <div>
      <Helmet><title>{title}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        page={page}
        name={ADMIN}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div className={styles.pageContainer}>
          <SettingHistory
            deviceID={deviceID}
            data={normalizedData}
            settingHistoryReady={ready}
          />
        </div>
      </div>
      <Footer />
    </div>
  )
}

SettingHistoryPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  data: PropTypes.object,
  pages: PropTypes.object,
  level: PropTypes.number,
}

export default withAppStore(injectIntl(SettingHistoryPage))
